import { render, staticRenderFns } from "./defineMenu.vue?vue&type=template&id=53787d34&scoped=true&"
import script from "./defineMenu.vue?vue&type=script&lang=js&"
export * from "./defineMenu.vue?vue&type=script&lang=js&"
import style0 from "./defineMenu.vue?vue&type=style&index=0&id=53787d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53787d34",
  null
  
)

export default component.exports